// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datatableTickets th:nth-child(1) {\n  display: none;\n}\n.datatableTickets td:nth-child(1) {\n  display: none;\n}\n.datatableTickets th:nth-child(2) {\n  display: none;\n}\n.datatableTickets td:nth-child(2) {\n  display: none;\n}\n.datatableTickets th:nth-child(3) {\n  display: none;\n}\n.datatableTickets td:nth-child(3) {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
